/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import logo from "./customer-boom.svg";
import diagram from "./diagram-boom.svg";
import Company from "./company";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      strong: "strong",
      a: "a",
      blockquote: "blockquote"
    }, props.components), {Header} = _components;
    if (!Header) _missingMdxReference("Header", true);
    return _jsxs(_Fragment, {
      children: [_jsxs("article", {
        children: [_jsx(Header, {}), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "A typical week:"
          }), " Typical doesn’t really exist when there are so many facets to achieving ", _jsx(_components.a, {
            href: "https://boomsupersonic.com/sustainability",
            children: "sustainable supersonic flight"
          }), "! I jump from improving our data quality for next year’s emissions accounting to advocating for policies that accelerate net-zero carbon fuels to working on ", _jsx(_components.a, {
            href: "https://www.prometheusfuels.com/",
            children: "partnerships for plasma-assisted combustion"
          }), " to reduce emissions."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Our approach:"
          }), " We’re working to remove the barriers to travel—not just the time it takes, but also the environmental impacts. Climate strongly informs our evaluation of customers and suppliers, and having set an internal cost of carbon helps us make data-driven, environmentally-conscious decisions."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "I’m proud of:"
          }), " Achieving carbon neutrality beginning in 2021 and publishing our first annual sustainability report in the next few weeks."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "I’m optimistic because:"
          }), " Even though aviation is a challenging sector to decarbonize, the rapid acceleration of sustainable aviation fuels over the past few years clearly shows that the future of aviation really will be sustainable. This isn’t yesteryear’s bio fuel, it’s a forward looking technology—pulling CO", _jsx("sub", {
            children: "2"
          }), " directly from the air to create net zero carbon fuel."]
        })]
      }), "\n", _jsxs(Company, {
        name: "Boom Supersonic",
        logo: logo,
        diagram: diagram,
        children: [_jsx(_components.p, {
          children: "Working to make travel faster, cleaner, and more beneficial to communities—creating a new model for strategic sustainability in aviation."
        }), _jsx(_components.p, {
          children: "They didn’t just tack on a climate program; they wove climate thinking into their DNA from day one."
        })]
      }), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Boom is working not just to be a leader in decarbonizing aviation, but to also ", _jsx("mark", {
            children: "drive systematic change across the entire industry"
          }), "."]
        }), "\n"]
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
